import script from "./UploadImageLimit.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadImageLimit.vue?vue&type=script&lang=ts&setup=true"

import "./UploadImageLimit.vue?vue&type=style&index=0&id=120338f7&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-120338f7"]])

export default __exports__